import React, {Component, lazy , Suspense} from 'react';
import "babel-polyfill";
import {Router, Route, Switch} from "react-router-dom";
import {Provider} from 'react-redux';
import {store, persistor} from './store/store'
import './providers/NotificationProvider/NotificationProvider.css';
import 'animate.css/animate.min.css';
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import {EventRegister} from './services/tools/EventRegister';
import NotificationProvider from './providers/NotificationProvider/NotificationProvider';
import history from './services/tools/history';
import * as actions from './actions';
import REST_API from './services/api/fetch';
import {Helmet} from "react-helmet";
import {ClipLoader} from "react-spinners";
import {PersistGate} from 'redux-persist/integration/react'
import {CONST} from "./consts/consts";
import Cookies from "universal-cookie";
import WhatsApp from "./res/img/whatsapp.svg"
import loadable from '@loadable/component'
import {getDomainForSettingRequests} from "./services/tools/uri";

const cookies = new Cookies();
let color = {}
const Home = loadable(() => import("./screens/Home/Home"))
const Recalculate = loadable(() => import("./screens/Recalculate/Recalculate"))
const Dashboard = loadable(() => import("./screens/Dashboard/Dashboard"))
const SpecsRegistration = loadable(() => import("./screens/SpecsRegistration/SpecsRegistration"))
const Order = loadable(() => import("./screens/Order/Order"))
const ConfirmInformation = loadable(() => import("./screens/ConfirmInformation/ConfirmInformation"))
const Payment = loadable(() => import("./screens/Payment/Payment"))
const Receipt = loadable(() => import("./screens/Receipt/Receipt"))
const ContentView = loadable(() => import("./screens/ContentView/ContentView"))
const Content = loadable(() => import("./screens/Content/Content"))
const FaqView = loadable(() => import("./screens/FaqView/FaqView"))
const GroupView = loadable(() => import("./screens/GroupView/GroupView"))
const NewsInfo = loadable(() => import("./components/NewsInfo/NewsInfo"))
const Sanhab = loadable(() => import("./components/Sanhab/Sanhab"))
const PayCardToCard = loadable(() => import("./components/PayCardToCard/PayCardToCard"))
const Error = loadable(() => import("./components/Error/Error"))
const Advertising = loadable(() => import("./components/Advertising/Advertising"))
const Blog = loadable(() => import("./components/Blog/Blog"))
const MemberDocuments = loadable(() => import("./components/MemberDocuments/MemberDocuments"))
const OrderArmanFamilyPackageLanding = loadable(() => import("./components/OrderArmanFamilyPackageLanding/OrderArmanFamilyPackageLanding"))
const UpdatePage = loadable(() => import("./components/UpdatePage/UpdatePage"))
const MapLocation = loadable(() => import("./components/MapLocation/MapLocation"))
const OnlineServices = loadable(() => import("./components/OnlineServices/OnlineServices"))
const LandingSeo = loadable(() => import("./components/LandingSeo/LandingSeo"))
const DayHealthApp = loadable(() => import("./screens/DayHealthApp/DayHealthApp"))
const DayCarDamageApp = loadable(() => import("./screens/DayCarDamageApp/DayCarDamageApp"))
const DayMeetCar = loadable(() => import("./screens/DayMeetCar/DayMeetCar"))
const DayCrona = loadable(() => import("./screens/DayCrona/DayCrona"))
const SiteMap = loadable(() => import("./screens/SiteMap/SiteMap"))
const Agent = loadable(() => import("./screens/Agent/Agent"))
const Damage = loadable(() => import("./screens/Damage/Damage"))
const Dehash = loadable(() => import("./screens/deHash/deHash"))

class App extends Component {
    constructor(props) {
        super(props);
        this.notificationDOMRef = React.createRef();
        this.notificationProvider = new NotificationProvider();
        this.rest = new REST_API();
        this.whatsAppPositionRight = -200;
        this.whatsAppPositionLeft = 20;
        this.state = {
            loaded: false,
            message: '',
            data: '',
            noData: '',
            whatsApp: "none",
            whatsAppPosition: 20,
        };
        this.whatsAppRef = React.createRef()
    }


    componentDidMount() {

        const domain = window.location.host.replace('www.', '')
        if (window.location.pathname === "/sitemap") {
            this.rest.post('agency/sitemap', {
                domain: domain
            })
                .then((resp) => {
                    // window.location.assign(resp.file)
                })
                .catch((resp) => {
                    EventRegister.emit('notification.open', resp.result.msg);
                })
        }
        if (this.whatsAppRef.current !== null) {
            this.whatsAppPositionRight = -(this.whatsAppRef.current && this.whatsAppRef.current.offsetWidth) + 14
        }
        window.addEventListener("scroll", () => {
            if (window.scrollY > 800) {
                store.getState().agency.agency && store.getState().agency.agency.raychat === null &&
                this.setState({whatsAppPosition: this.whatsAppPositionRight, whatsApp: "none"})
            } else {
                store.getState().agency.agency && store.getState().agency.agency.raychat === null &&
                this.setState({whatsAppPosition: this.whatsAppPositionLeft})
            }
        })

        window.location.origin === "https://panel.armanins24.com" && window.location.assign("https://panel.bimic.ir")
        window.addEventListener("load", function () {
            // Set a timeout...
        });
        this.listenerNotif = EventRegister.addEventListener('notification.open', (data) => {
            this.notificationProvider.show(this.notificationDOMRef, {message: data, title: 'خطا', type: 'danger'});
        });
        this.listenerMessage = EventRegister.addEventListener('message.open', (data) => {
            this.notificationProvider.show(this.notificationDOMRef, {message: data, title: '', type: 'info'});
        });


        //Redux initialize :

        // --- Mmber ---

        let member = cookies.get('member')
        if (member && member !== '') {
            if (member.isLogin === true) {
                store.dispatch(actions.login(member));
            }
        }
        this.getData(member)

        // --- END ---
    }

    componentWillUnmount() {
        EventRegister.removeEventListener(this.listenerNotif);
        EventRegister.removeEventListener(this.listenerMessage);
    }

    handleHomePage() {
        let domain = window.location.host.replace('www.', '')
        if (domain === "d1.didarapp.ir") {
            return <Route exact path="/" component={Error}/>
        } else {
            return <Route exact path="/" component={Home}/>
        }

    }

    async getData() {
        if (cookies.get('member') !== '') {
            try {
                await this.rest.get('user/check-login')
                    .then(resp => {
                        if (resp.status === false) {
                            store.dispatch(actions.logout())
                        }
                    })
            } catch (e) {
                store.dispatch(actions.logout())
            }

        }
        //Fetch data :
        await this.rest.post('agency/detail', {
            // domain: 'goldeninsurer.ir',
            domain: getDomainForSettingRequests()
        }).then(resp => {

            if (typeof resp != "undefined") {
                if (resp) {
                    if (resp.status) {
                        this.setState({
                            data: resp.result.data
                        })
                        // if (resp.result.data.company.id === 12) {
                        //     this.setState({
                        //         loaded: true,
                        //         message: "مشتریان گرامی، به علت بروزرسانی زیر ساختهای شرکت، سفارش گیری آنلاین انواع بیمه نامه تا تاریخ 1401/11/30 موقتا غیرفعال می باشد."
                        //     });
                        // }
                        if (resp.result.data.site_setting.status.active) {
                            store.dispatch(actions.setAgency(resp.result.data));
                            this.setColors(resp.result.data);
                            this.color()
                            this.setState({loaded: true});
                        } else if (resp.result.data && !resp.result.data.site_setting.status.active && !resp.result.data.site_setting.status.expired && resp.result.data.company.id === 19) {
                            window.location.assign('https://armanins24.com/')
                        } else {
                            this.setState({loaded: true, message: resp.result.data.site_setting.status.message});
                        }
                    } else {

                        if (resp.result.msg === "این نمایندگی موجود نیست و یا غیرفعال است") {
                            this.setState({
                                loaded: true,
                            })
                            history.push("/error")
                        }
                        if (resp.result && resp.result.data && resp.result.data.site_setting.status.active) {
                            store.dispatch(actions.setAgency(resp.result.data));
                            this.setColors(resp.result.data);
                            this.color()
                            this.setState({
                                loaded: true,
                                message: resp.result && resp.result.msg,
                                noData: resp.result && resp.result.data
                            });
                        } else if (resp.result.msg !== "این نمایندگی موجود نیست و یا غیرفعال است") {
                            this.setState({
                                loaded: true,
                                message: resp.result && resp.result.data && resp.result && resp.result.data.site_setting.status.message
                            });
                        }
                    }
                }
            }
        })
            .catch((error) => {
                console.log(error)
            })
    }

    raychat() {
        const t = document.createElement("script");
        t.async = true;
        let matches = store.getState().agency.agency && store.getState().agency.agency.raychat && store.getState().agency.agency && store.getState().agency.agency.raychat.match(/.*o=\s*(.*)\s+;/);
        if (matches && matches.length > 0) {
            let o = matches[1];
            localStorage.getItem("rayToken") ? t.src = "https://app.raychat.io/scripts/js/" + o + "?rid=" + localStorage.getItem("rayToken") + "&href=" + window.location.href : t.src = "https://app.raychat.io/scripts/js/" + o;
            document.body.appendChild(t);
        }
    }


    renderMetas() {
        const googleAnalyticsId = this.state.data.agency && CONST.GOOGLE_ANALITYC[this.state.data.agency.agency_id];
        const googleTagManagerId = this.state.data.agency && CONST.GOOGLE_TAG_MANAGER[this.state.data.agency.agency_id];

        if (!this.state.loaded)
            return null;

        const agency = store.getState().agency;
        return (
            <>
                {
                    agency.isSet !== false &&
                    <>
                        <Helmet>
                            <title>{agency.site_setting.meta_tag.title}</title>

                            {store.getState().agency.agency && store.getState().agency.agency.logo != null &&
                            <link rel="icon" type="image/x-icon"
                                  href={store.getState().agency.agency && store.getState().agency.agency.logo}/>
                            }
                            {store.getState().agency.agency && store.getState().agency.agency.logo == null &&
                            <link rel="icon" type="image/x-icon"
                                  href={store.getState().agency.site_setting.view.favicon}/>
                            }
                            <meta name="description" content={agency.site_setting.meta_tag.description || agency.site_setting.meta_tag.title}/>
                            <meta name="keywords" content={agency.site_setting.meta_tag.keywords}/>
                            <meta property="og:title" content={agency.site_setting.meta_tag.og.title}/>
                            <meta property="og:type" content={agency.site_setting.meta_tag.og.type}/>
                            <meta property="og:url" content={agency.site_setting.meta_tag.og.url}/>
                            <meta property="og:image" content={agency.site_setting.meta_tag.og.image}/>
                            <meta property="og:site_name" content={agency.site_setting.meta_tag.og.site_name}/>
                            <link rel="preconnect" href="https://panel.bimic.ir"/>
                            <link rel="dns-prefetch" href="https://panel.bimic.ir"/>
                            <link rel="preconnect" href="https://www.googletagmanager.com" crossOrigin/>
                            <link rel="dns-prefetch" href="https://www.googletagmanager.com"/>
                            <link rel="preconnect" href="https://www.google-analytics.com" crossOrigin/>
                            <link rel="dns-prefetch" href="https://www.google-analytics.com"/>
                            <link rel="stylesheet" href="https://unpkg.com/leaflet@1.0.1/dist/leaflet.css" />
                            <link rel="preload" href="./res/fonts/vazir-font-v18.0.0/Farsi-Digits/Vazir-FD.ttf" as="font" crossOrigin/>


                            {
                                this.state.data.agency.agency_id === 3173 &&
                                <meta name="google-site-verification"
                                      content="48i--Hg6SbJvGV8k4tNDUurcOrF3qwtkKE40mIGuJzk"/>
                            }
                            {
                                this.state.data.agency.agency_id === 3329 &&
                                <meta name="google-site-verification"
                                      content="B_igGTGgURaHCxM8UGKyXUrKsF-jHxNrF9NnJysUReY"/>
                            }
                            {(agency.site_setting.meta_tag.enamad.verify_code != '' && agency.site_setting.permissions.enamad) &&
                            <meta name="enamad" content={agency.site_setting.meta_tag.enamad.verify_code}/>
                            }
                            {
                                store.getState().agency.company && store.getState().agency.company.id === 24 &&
                                <meta name="google-site-verification" content="kS1Fm_HLKYhK9l8SzNSRxSV5jzScjta5YRzdjZy_DkU" />
                            }
                            {
                                googleAnalyticsId !== undefined &&
                                <script async src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}/>

                            }
                            {
                                googleAnalyticsId !== undefined &&
                                <script async>
                                    {`
                                window.dataLayer = window.dataLayer || [];
                                function gtag(){dataLayer.push(arguments);}
                                gtag('js', new Date());
                                gtag('config', '${googleAnalyticsId}');
                            `}
                                </script>
                            }
                            {
                                googleTagManagerId !== undefined &&
                                <script async>
                                    {`
                               (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                                })(window,document,'script','dataLayer','${googleTagManagerId}');
                            `}
                                </script>
                            }
                            <script
                                type="application/ld+json"
                                dangerouslySetInnerHTML={{ __html: JSON.stringify({
                                        "@context": "https://schema.org/",
                                        "@type": "Review",
                                        "reviewRating": {
                                            "@type": "Rating",
                                            "ratingValue": "5"
                                        },
                                        "name": "Customer",
                                        "author": {
                                            "@type": "Person",
                                            "name": "Customer"
                                        },
                                        "reviewBody": "Customer",
                                        "publisher": {
                                            "@type": "Organization",
                                            "name": "کاربر"
                                        }
                                    })
                                }}
                            />
                        </Helmet>
                    </>
                }
            </>
        );
    }

    setColors(data) {
        switch (store.getState().agency.agency && store.getState().agency.agency.agency_id) {
            case 331 :
                return(
                    color.Primary_color = "#0099a7",
                        color.Secondry_color = "#0099a7",
                        color.Tertiary_color = "#0099a7",
                        color.Quaternary_color = "#0099a7",
                        color.Quinary_color = "#0099a7",
                        color.Senary_color = data.site_setting.view.colors.sixth,
                        color.Text_color = data.site_setting.view.colors.text_color
                )
            case 3361 :
                return(
                    color.Primary_color = "#046ffc",
                        color.Secondry_color = "#046ffc",
                        color.Tertiary_color = data.site_setting.view.colors.third,
                        color.Quaternary_color = "#046ffc",
                        color.Quinary_color = "#046ffc",
                        color.Senary_color = data.site_setting.view.colors.sixth,
                        color.Text_color = data.site_setting.view.colors.text_color
                )
            default :
                return (
                    color.Primary_color = data.site_setting.view.colors.primary,
                        color.Secondry_color = data.site_setting.view.colors.second,
                        color.Tertiary_color = data.site_setting.view.colors.third,
                        color.Quaternary_color = data.site_setting.view.colors.fourth,
                        color.Quinary_color = data.site_setting.view.colors.fifth,
                        color.Senary_color = data.site_setting.view.colors.sixth,
                        color.Text_color = data.site_setting.view.colors.text_color
                )
        }
    }

    color(data) {
        document.body.style.setProperty('--Primary_color',color.Primary_color )
        document.body.style.setProperty('--Secondry_color', color.Secondry_color)
        document.body.style.setProperty('--Tertiary_color', color.Tertiary_color)
        document.body.style.setProperty('--Quaternary_color', color.Quaternary_color)
        document.body.style.setProperty('--Quinary_color', color.Quinary_color)
        document.body.style.setProperty('--Senary_color', color.Senary_color)
        document.body.style.setProperty('--Text_color', color.Text_color)
    }

    getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "tablet";
        }
        if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "mobile";
        }
        return "desktop";
    };

    render() {
        const styles = {
            whats_app_detail: {
                flexDirection: "row-reverse",
                padding: 0,
            },
            whats_app_detail_img: {
                marginLeft: 0,
                marginRight: 40,
                padding: 10,
            }
        }

        if (!this.state.loaded && window.location.origin !== "https://bimic.ir") {
            return (
                <div style={{position: 'absolute', right: "calc(50% - 20px)", top: "calc(50% - 15px)"}}>
                    <ClipLoader
                        sizeUnit={"px"}
                        size={30}
                        color={'#123abc'}
                        loading={this.state.loading}
                    />
                </div>
            );
        }

        const renderMassengers = () => {
            let device = this.getDeviceType();
            if (device === 'desktop') {
                if (store.getState().agency.agency && store.getState().agency.agency.raychat) {
                    this.raychat();
                } else if (store.getState().agency.agency && store.getState().agency.agency.whatsapp && store.getState().agency.agency && store.getState().agency.agency.whatsapp !== "[]") {
                    return (
                        <div style={{right: this.state.whatsAppPosition}} ref={this.whatsAppRef} className="whats_app">
                            <div style={{display: this.state.whatsApp}} className='whats_app_drawer'>
                                {JSON.parse(store.getState().agency.agency && store.getState().agency.agency.whatsapp).map((item) => {
                                    return (
                                        <>
                                            <a target="_blank"
                                               href={`https://web.whatsapp.com/send?phone=${item.value && item.value.length === 11 ? "+98" + item.value.substr(1, 11) : item.value}`}>
                                                <span><img alt={"arrow"} src={require("./res/img/arrow3.png")}/></span>
                                                <span>{item.title}</span>
                                            </a>
                                        </>
                                    )
                                })}
                            </div>
                            <div onClick={() => {
                                this.setState({whatsApp: this.state.whatsApp === "flex" ? "none" : "flex"})
                            }}
                                 style={this.state.whatsAppPosition === this.whatsAppPositionRight ? styles.whats_app_detail : {}}
                                 className='whats_app_detail'>
                                <span style={{pointerEvents: 'none'}}>{"از طریق واتس اپ با ما گفتگو کنید"}</span>
                                <img
                                    alt={"whatsApp"}
                                    style={this.state.whatsAppPosition === this.whatsAppPositionRight ? styles.whats_app_detail_img : {}}
                                    onClick={() => {
                                        this.setState({whatsAppPosition: this.whatsAppPositionLeft})
                                    }} className="whats_app_detail_img" src={WhatsApp}/>
                            </div>
                        </div>
                    );
                }
            } else {
                if (store.getState().agency.agency && store.getState().agency.agency.raychat) {
                    this.raychat();
                } else if (store.getState().agency.agency && store.getState().agency.agency.whatsapp && store.getState().agency.agency && store.getState().agency.agency.whatsapp !== "[]") {
                    return (
                        <div style={{right: this.state.whatsAppPosition}} ref={this.whatsAppRef} className="whats_app">
                            <div style={{display: this.state.whatsApp}} className='whats_app_drawer'>
                                {JSON.parse(store.getState().agency.agency && store.getState().agency.agency.whatsapp).map((item) => {
                                    return (
                                        <>
                                            <a target="_blank"
                                               href={`https://api.whatsapp.com/send?phone=${item.value && item.value.length === 11 ? "+98" + item.value.substr(1, 11) : item.value}`}>
                                                <span><img alt={"arrow"} src={require("./res/img/arrow3.png")}/></span>
                                                <span>{item.title}</span>
                                            </a>
                                        </>
                                    )
                                })}
                            </div>
                            <div onClick={() => {
                                this.setState({whatsApp: this.state.whatsApp === "flex" ? "none" : "flex"})
                            }}
                                 style={this.state.whatsAppPosition === this.whatsAppPositionRight ? styles.whats_app_detail : {}}
                                 className='whats_app_detail'>
                                <span
                                    style={{pointerEvents: 'none'}}>{store.getState().agency.site_setting.view.content.static.adv === null ? "از طریق واتس اپ با ما گفتگو کنید" : "واتس اپ "}</span>
                                <img
                                    alt={"whatsApp"}
                                    style={this.state.whatsAppPosition === this.whatsAppPositionRight ? styles.whats_app_detail_img : {}}
                                    onClick={() => {
                                        this.setState({whatsAppPosition: this.whatsAppPositionLeft})
                                    }} className="whats_app_detail_img" src={WhatsApp}/>
                            </div>
                        </div>
                    );
                }
            }
        }

        return (
            <Provider store={store}>
                {renderMassengers()}
                <PersistGate loading={null} persistor={persistor}>
                    <>
                        {this.state.message == '' && this.renderMetas()}
                        <ReactNotification ref={this.notificationDOMRef}/>
                        <Router history={history} forceRefresh={false}>
                            <Switch>
                                {this.handleHomePage()}
                                <Route exact path="/insurance/:insurance_type/:userName?/:uuid?" component={Home}/>
                                <Route exact path="/insurance/:insurance_type/:userName?/refer=uuid?"
                                       component={Home}/>
                                <Route path="/recalculate" component={Recalculate}/>
                                <Route path="/profile" component={Dashboard}/>
                                <Route path="/specs-registration" component={SpecsRegistration}/>
                                <Route path="/Order" component={Order}/>
                                <Route path="/confirm-information/:insurance_id?" component={ConfirmInformation}/>
                                <Route path="/payment" component={Payment}/>
                                <Route path="/receipt/:uuid" component={Receipt}/>
                                <Route exact path="/post/:id/:slug?" component={ContentView}/>
                                <Route exact path="/content/:type" component={Content}/>
                                <Route exact path="/content/:id/:title" component={ContentView}/>
                                <Route path="/faq/:id/:slug?" component={FaqView}/>
                                <Route path="/content/group/:id/:title?" component={GroupView}/>
                                <Route path="/news/:id/:slug?" component={NewsInfo}/>
                                <Route path="/sanhab" component={Sanhab}/>
                                <Route path="/PayCardToCard" component={PayCardToCard}/>
                                <Route path="/error" component={Error}/>
                                <Route exact path="/landing/Advertising" component={Advertising}/>
                                <Route exact path="/blog/:id?/:slug?" component={Blog}/>
                                <Route exact path="/MemberDocuments" component={MemberDocuments}/>
                                <Route path={'/FamilyPackages'} component={Home}/>
                                <Route path={'/ArmanFamilyPackage'} component={OrderArmanFamilyPackageLanding}/>
                                <Route path={'/health/app'} component={DayHealthApp}/>
                                <Route path={'/day/car-damage/app'} component={DayCarDamageApp}/>
                                <Route path={'/didar_khodro/app'} component={DayMeetCar}/>
                                <Route path={'/crona'} component={DayCrona}/>
                                <Route path={'/UpdatePage'} component={UpdatePage}/>
                                <Route path={'/agents'} component={Agent}/>
                                <Route path={'/damage'} component={Damage}/>
                                <Route path={'/hash'} component={Dehash}/>
                                <Route
                                    path={`/sitemap-${store.getState().agency.agency && store.getState().agency.agency.agency_id}`}
                                    component={SiteMap}/>
                                {store.getState().agency.company && store.getState().agency.company.id === 19 &&
                                <>
                                    <Route path={'/agents'} component={MapLocation}/>
                                    <Route exact path="/onlineservices" component={OnlineServices}/>
                                </>
                                }
                                {
                                    store.getState().agency.company && store.getState().agency.company.id === 24 &&
                                    <Route path={'/landing/seo'} component={LandingSeo}/>
                                }
                                <Route  component={Error}/>
                            </Switch>
                        </Router>
                        {
                            this.state.message !== '' &&
                            <>
                                <div style={{
                                    width: '100vw',
                                    height: '100%',
                                    position: 'fixed',
                                    top: 0,
                                    backgroundColor: 'rgba(0,0,0,0.5)'
                                }}/>
                                <p className='sAlert Warning' style={{
                                    minWidth: '150px',
                                    width: '75%',
                                    margin: 'auto',
                                    textAlign: 'center',
                                    position: 'fixed',
                                    left: 0,
                                    right: 0,
                                    top: 0,
                                    bottom: 0,
                                    maxHeight: 50
                                }}>
                                    {this.state.message}
                                </p>
                            </>
                        }
                    </>
                </PersistGate>
            </Provider>

        );
    }
}


export default App;
